var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 8,
    viewBox: "0 0 10 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.7408 0L0.0211339 1.87552H1.66363L2.68445 0H1.7408ZM3.13457 0L2.11409 1.87552H7.88582L6.86534 0H3.13457ZM7.31552 0L8.33601 1.87552H9.97896L8.25929 0H7.31552ZM0 2.25062L4.08147 7.05667L1.65977 2.25062H0ZM2.10318 2.25062L5.00005 8L7.89691 2.25062H2.10318ZM8.34068 2.25062L5.91853 7.05667L10 2.25062H8.34068Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon);
export default __webpack_public_path__ + "static/media/icon.3cd8dd77eb0e630fba5ae7de089e2e75.svg";
export { ForwardRef as ReactComponent };